<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("feedbackForms") }}</div>
        <div class="section-subTitle my-2">
          {{ $t("feedback_dash_msg") }}
        </div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Feedback Forms')"
          variant="default"
          to="add-form"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="searchFormList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 120px">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>
              <img
                v-if="this.columnName != 'form_name'"
                @click="onSortValue('form_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('form_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('form_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              Forms
            </th>
          </tr>
        </thead>
        <tbody v-for="(form, formKey) in Forms" :key="formKey">
          <tr>
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    form.is_active === 'Y'
                      ? 'active'
                      : form.is_active === 'N' && 'inactive'
                  "
                />

                <div
                  class="blue-icon cursor-pointer ml-2"
                  @click.prevent.stop="onResponseForm(form)"
                  v-b-tooltip="'Responses'"
                  tabindex="0"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="#4682B4"
                    class="bi bi-chat-fill"
                    viewBox="0 0 18 18"
                  >
                    <path
                      d="M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9.06 9.06 0 0 0 8 15z"
                    />
                  </svg>
                </div>

                <i
                  class="icon-eye blue-icon cursor-pointer ml-2"
                  style="width: 18px; height: 18px"
                  @click.prevent.stop="onViewForm(form)"
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></i>

                <i
                  class="cursor-pointer ml-2"
                  :to="{ name: 'Send Form', params: { form_id: form.f_id } }"
                  v-b-tooltip="'Send'"
                  tabindex="0"
                ></i>
              </div>
            </td>

            <td>{{ form.form_name }}</td>
          </tr>
        </tbody>
        <tbody v-if="Forms.length == 0">
          <tr>
            <td colspan="2">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      Forms: [],

      debounce: null,
      searchValue: "",

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.getFormList();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getFormList();
      } else {
        this.currentPage = event;
        this.getFormList();
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getFormList();
    },
    searchFormList(search) {
      this.getFormList(1, search);
    },
    getFormList: function (page = undefined, search = undefined) {
      let payload = {
        limit: this.perPage,
        currentPage: page ? page : this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
      };
      MasterService.GetAllForms(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Forms = data.Records;

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              vue.toasted.show(data.message || "Please try later");
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onViewForm: function (form) {
      this.$router.push({
        path: "/cinema-manager/view-form",
        query: { form_id: form.f_id },
      });
    },
    onResponseForm: function (form) {
      this.$router.push({
        path: "/cinema-manager/response-form",
        query: { form_id: form.f_id },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/FeedbackFormComponents/forms.vue